import * as React from "react";
import type { SVGProps } from "react";
const SvgIconVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={512}
    height={512}
    data-name="Layer 1"
    {...props}
  >
    <path
      fill="#242323"
      d="M256 481C131.93 481 31 380.07 31 256S131.93 31 256 31s225 100.93 225 225-100.93 225-225 225m0-434.27C140.61 46.73 46.73 140.61 46.73 256S140.61 465.27 256 465.27 465.27 371.39 465.27 256 371.39 46.73 256 46.73"
    />
    <path
      fill="#242323"
      d="M390.21 254.15 188.4 137.63c-1.43-.82-3.21.21-3.21 1.85v233.03c0 1.65 1.78 2.67 3.21 1.85l201.81-116.52c1.43-.82 1.43-2.88 0-3.7L188.4 137.62c-1.43-.82-3.21.21-3.21 1.85V372.5c0 1.65 1.78 2.67 3.21 1.85l201.81-116.52c1.43-.82 1.43-2.88 0-3.7Z"
    />
  </svg>
);
export default SvgIconVideo;
